// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3ZQG-","selected":"Chip_selected__2l2Kc"};